import React from "react";

export function checkIfHasData(model) {
  return model.diagnoses.length > 0 || model.problems.length > 0;
}

export default function DxProblemsTile({ model, title }) {
  let hasData = checkIfHasData(model);
  return (
    <React.Fragment>
      <div className="title">
        {title}
        <span className="count">{Object.keys(model).length}</span>
      </div>
      <div className="tile-content dx-problems">
        {!hasData && <div className="no-results">No Dx/Problems</div>}
        {hasData && content(model)}
      </div>
    </React.Fragment>
  );
}

function content(model, className) {
  return Object.keys(model).map((key) => (
    <section key={key} className={className}>
      <div className="label">{key}:</div>
      {model[key].map((value) => (
        <div className="value" key={value}>
          {value}
        </div>
      ))}
    </section>
  ));
}
